import { render, staticRenderFns } from "./SupervisionOldVersionNotice.vue?vue&type=template&id=2381497f"
import script from "./SupervisionOldVersionNotice.vue?vue&type=script&lang=js"
export * from "./SupervisionOldVersionNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports